import { http } from "@/helpers/http";
import APP_URL from "@/helpers/urls";

const baseURL = APP_URL("wallet");

export default {
  namespaced: true,

  actions: {

    generateQr({ state, commit, rootState }, payload) {
      http.post(baseURL + "/gen-qr", payload.data)
        .then(response => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch(error => {
          if (payload.callback) payload.callback(false);
        })
    },

    fetchReport({ state, commit, rootState }, payload) {
      http.get(baseURL + "/report?from=" + payload.from + "&to=" + payload.to + "&format=" + payload.format)
        .then(response => {
          if (payload.callback) payload.callback(true, response.data);
        })
        .catch(error => {
          if (payload.callback) payload.callback(false);
        })
    },

    // FOR TEST ONLY
    // loadBalance({ state, commit, rootState }, payload) {
    //   http.post(baseURL + "/balance", payload.data)
    //     .then(response => {
    //       if (payload.callback) payload.callback(true, response.data);
    //     })
    //     .catch(error => {
    //       if (payload.callback) payload.callback(false);
    //     })
    // }
  },
};
